"use client";
import { createContext, useContext, ReactNode } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { IGoogleMapsContextType } from "../lib";

const GoogleMapsContext = createContext<IGoogleMapsContextType>({
  isLoaded: false,
  loadError: false,
});

export const GoogleMapsProvider = ({ children }: { children: ReactNode }) => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!googleMapsApiKey) {
    throw new Error(
      "no google maps api key defined NEXT_PUBLIC_GOOGLE_MAPS_API_KEY",
    );
  }
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey,
  });

  if (loadError) {
    console.warn("[Provider] Unable to load google maps", loadError);
  }

  return (
    <GoogleMapsContext.Provider
      value={{
        isLoaded,
        loadError: !!loadError,
      }}
    >
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
